import {
  Award,
  BookHeart,
  Building2,
  Castle,
  Flag,
  Landmark,
  MoonStar,
  ScrollText,
  type LucideIcon,
} from 'lucide-react';
import type { ContentCategory } from '@shared/api.interface';
import type { DurationRange } from '@/utils/topic-duration';
import { getCategoryStyle } from '@/utils/topic-category-style';

// 筛选按钮上的题材图标：和题材内容相关，颜色沿用题材色
const CATEGORY_ICONS: Record<ContentCategory, LucideIcon> = {
  traditional_culture: Landmark,
  idiom_fable: ScrollText,
  patriotic_feeling: Flag,
  character_spirit: Award,
  city_feature: Building2,
  myth_legend: MoonStar,
  classic_fairy_tale: Castle,
  picture_book_story: BookHeart,
};

export function CategoryFilterIcon({ category, className = 'h-3.5 w-3.5' }: { category: string; className?: string }) {
  const Icon = CATEGORY_ICONS[category as ContentCategory];
  const color = getCategoryStyle(category).dot;
  if (!Icon) {
    return <span aria-hidden className="h-2 w-2 shrink-0 rounded-full" style={{ background: color }} />;
  }
  return <Icon aria-hidden strokeWidth={1.75} className={`shrink-0 ${className}`} style={{ color }} />;
}

// 时长按钮上的小表盘：暖橙细圈，时间越长填得越满（1/4 圈到整圈），纯装饰
const DURATION_LEVEL: Record<DurationRange, number> = {
  under_90: 1,
  '90_to_120': 2,
  '120_to_150': 3,
  over_150: 4,
};

const DIAL_RING = '#D9B48F';
const DIAL_FILL = '#E39A5C';

export function DurationDialIcon({ range, className = 'h-[15px] w-[15px]' }: { range: DurationRange; className?: string }) {
  const level = DURATION_LEVEL[range] ?? 1;
  const angle = (level / 4) * 2 * Math.PI;
  const x = (8 + 5.6 * Math.sin(angle)).toFixed(2);
  const y = (8 - 5.6 * Math.cos(angle)).toFixed(2);
  return (
    <svg aria-hidden viewBox="0 0 16 16" className={`shrink-0 ${className}`}>
      <circle cx="8" cy="8" r="7" fill="none" stroke={DIAL_RING} strokeWidth="1.3" />
      {level >= 4 ? (
        <circle cx="8" cy="8" r="5.6" fill={DIAL_FILL} opacity="0.9" />
      ) : (
        <path d={`M8 8 L8 2.4 A5.6 5.6 0 ${level > 2 ? 1 : 0} 1 ${x} ${y} Z`} fill={DIAL_FILL} opacity="0.9" />
      )}
    </svg>
  );
}
